import Link from 'next/link';
import { useTranslations } from 'next-intl';
import { Button } from '@/components/ui/Button';
import Image from 'next/image';

export default function YesNoCTA() {
  const t = useTranslations('tarot.card.cta');

  return (
    <div className="my-20 relative max-w-xl mx-auto bg-gradient-to-br from-[#18122b] via-[#2a1a4d] to-[#6A3683]/80 rounded-2xl border border-[#A45DE8]/40 shadow-[0_0_24px_#A45DE8]/20 p-8 w-full flex flex-col items-center text-center overflow-hidden">
      <h2 className="text-3xl font-serif text-white mb-4 pb-3 mx-auto max-w-md">
        {t('headline')}
      </h2>
      <p className="mb-6 text-gray-300 text-lg">{t('description')}</p>
      
      <div className="flex items-center justify-center gap-4 mb-4">
        <Image
          src="/images/oracle-luna.png"
          alt="Luna the Oracle"
          width={64}
          height={64}
          className="rounded-full shadow-[0_0_15px_rgba(164,93,232,0.3)]"
        />
        <Link href="/#hero-section" passHref>
          <Button variant="primary" className="w-full md:w-auto">
            {t('button')}
          </Button>
        </Link>
      </div>

      <div className="text-sm text-gray-300 mt-4 flex items-center justify-center space-x-4">
        <div className="flex items-center">
          <span className="text-[#D4B6FF] mr-1">✧</span>
          <span>{t('badge.free')}</span>
        </div>
        <div className="flex items-center">
          <span className="text-[#D4B6FF] mr-1">✧</span>
          <span>{t('badge.private')}</span>
        </div>
      </div>
    </div>
  );
} 